export default [
  {
    name: 'car-wash',
    path: '/car-wash',
    component: () => import(/* webpackChunkName: "car-wash" */ '@/views/CarWash.vue')
  }
];
